import { Messages } from "../messages/toastMessages";

export {};
export const BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT = {
  Flights: "Flights",
  Hotels: "Stays",
  Review: "Review",
  ReviewNew: "ReviewNew",
  Travelers: "Travelers",
  TravelersFlight: "TravelersFlight",
  TravelersHotel: "TravelersHotel",
  Payment: "Payment",
  Activities: "Activities",
};

export const INITIAL_BREADCRUMBS_LIST = true
  ? [
      {
        id: 1,
        value: BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Flights,
        checked: true,
        activeCrumbs: true,
        heading: Messages["booking.header.flight.stays"].message,
        price: "$895",
        showSearchFilter: true,
        showPreferencesFilter: true,
        data: {},
      },
      {
        id: 2,
        value: BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Hotels,
        checked: false,
        activeCrumbs: false,
        heading: Messages["booking.header.flight.stays"].message,
        price: "$895",
        showSearchFilter: true,
        showPreferencesFilter: true,
        data: {},
      },
      {
        id: 3,
        value: "ReviewNew",
        checked: false,
        activeCrumbs: false,
        heading: Messages["booking.review"].message,
        price: "$1,297",
        showSearchFilter: false,
        showPreferencesFilter: false,
        data: {},
      },
    ]
  : [
      {
        id: 1,
        value: BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Flights,
        checked: true,
        activeCrumbs: true,
        heading: Messages["booking.header.flight.stays"].message,
        price: "$895",
        showSearchFilter: true,
        showPreferencesFilter: true,
        data: {},
      },
      {
        id: 2,
        value: BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Hotels,
        checked: false,
        activeCrumbs: false,
        heading: Messages["booking.header.flight.stays"].message,
        price: "$895",
        showSearchFilter: true,
        showPreferencesFilter: true,
        data: {},
      },
      {
        id: 3,
        value: "Review",
        checked: false,
        activeCrumbs: false,
        heading: Messages["booking.review"].message,
        price: "$1,297",
        showSearchFilter: false,
        showPreferencesFilter: false,
        data: {},
      },
      // {
      //   id: 4,
      //   value: BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Travelers,
      //   checked: false,
      //   activeCrumbs: false,
      //   heading: "Traveler Information",
      //   price: "$1,297",
      //   showSearchFilter: false,
      //   showPreferencesFilter: false,
      //   data: {},
      // },
      {
        id: 5,
        value: BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.TravelersFlight,
        checked: false,
        activeCrumbs: false,
        heading: Messages["booking.traveler.info"].message,
        // heading: "Who's Travelling",
        price: "$1,297",
        showSearchFilter: false,
        showPreferencesFilter: false,
        data: {},
      },
      // {
      //   id: 6,
      //   value: BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.TravelersHotel,
      //   checked: false,
      //   activeCrumbs: false,
      //   heading: "Traveler Information",
      //   price: "$1,297",
      //   showSearchFilter: false,
      //   showPreferencesFilter: false,
      //   data: {},
      // },

      {
        id: 7,
        value: "Payment",
        checked: false,
        activeCrumbs: false,
        heading: "Payment",
        price: "",
        showSearchFilter: false,
        showPreferencesFilter: false,
        data: {
          flight: {
            heading: "Flights",
            list: [
              {
                key: "3 Travelers",
                value: "$840.00",
              },
              {
                key: "Taxes +  Fees",
                value: "$75.00",
              },
              {
                key: "Total",
                value: "$925.00",
              },
            ],
          },
          hotel: {
            heading: "Hotels",
            list: [
              {
                key: "2 Rooms",
                value: "$642.00",
              },
              {
                key: "Taxes +  Fees",
                value: "$80.00",
              },
              {
                key: "Total",
                value: "$722.00",
              },
            ],
          },
        },
      },
    ];

export const REVIEW_STEPS = {
  flight: "FLIGHT",
  stay: "STAY",
  traveler: "TRAVELER",
  roomAssignment: "ROOM ASSINGMENT",
  payment: "PAYMENT",
};

export const REVIEW_STEPS_NEXT_BTN = {
  traveler: "Next: Travelers",
  roomAssignment: "Next: Room Assignment",
  payment: "Next: Payment Method",
  complete: "Complete Purchase",
  bookingProgress: "Please wait...",
};
